import { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import { useHistory, useParams } from 'react-router-dom';
import { fetchUserSounds } from 'flow/actions/sounds-actions';
import {
    fetchVoicemailSettings,
    updateVoicemailSettings,
} from 'flow/actions/voicemail-actions';
import Page from 'flow/components/Setting/Page';
import VoicemailSettingsPlaybackPicker from 'flow/components/settings/VoicemailSettingsPlaybackPicker';
import Loading from 'flow/components/ui-components/Loading';
import useAppContext from 'flow/hooks/useAppContext';
import useVoicemail from 'flow/hooks/useVoicemail';
import { routes } from 'flow/types/routes';

import { ExtensionKey } from 'flow/types/EntityKeys';
import { generatePath } from 'flow/utils/router-utils';

const SettingsVoicemailBusy = () => {
    const { i18next } = useAppContext();
    const history = useHistory();
    const dispatch = useAppDispatch();

    const { extensionKey } = useParams<{
        extensionKey: ExtensionKey;
    }>();
    const { voicemailSettings } = useVoicemail(extensionKey);

    const userSounds = useAppSelector((state) => state.sounds.get('sounds'));

    useEffect(() => {
        dispatch(fetchUserSounds());
        if (!voicemailSettings) {
            dispatch(fetchVoicemailSettings(extensionKey));
        }
    }, [dispatch, extensionKey, voicemailSettings]);

    if (!voicemailSettings || !userSounds) {
        return <Loading />;
    }

    const handleClick = (userSoundKey: string) => {
        const soundDTO = {
            key: userSoundKey,
        };
        const updatedSettings = {
            key: voicemailSettings.get('key'),
            busySound: soundDTO,
        };
        dispatch(updateVoicemailSettings(extensionKey, updatedSettings));
    };

    return (
        <Page
            header="settings.voicemail.busy"
            onClickBack={() =>
                history.push(
                    generatePath(routes['settings.voicemail'], {
                        extensionKey,
                    }),
                )
            }
        >
            <VoicemailSettingsPlaybackPicker
                selectedSoundKey={voicemailSettings.getIn(['busySound', 'key'])}
                standardSoundDTO={voicemailSettings.get(
                    'standardVoicemailSound',
                )}
                ownRecordingFile={voicemailSettings.get('busySoundFile')}
                privateUserSoundList={userSounds.filter((sound) =>
                    sound.get('privateSound'),
                )}
                handleClick={handleClick}
                subheader={i18next.t('settings.voicemail_busy')}
            />
        </Page>
    );
};

export default SettingsVoicemailBusy;
